import { useNavigate } from 'react-router-dom';

const NAV = [
  ['/hr/dashboard', 'Attendance'],
  ['/hr/employees', 'Employees'],
  ['/hr/locations', 'Locations'],
  ['/hr/reports', 'Reports'],
  ['/hr/notifications', 'Notifications'],
  ['/hr/tracking', 'Tracking'],
];

// Same header and navigation as the other HR pages
export default function HRHeader({ title, user, active }) {
  const navigate = useNavigate();
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/hr/login');
  };

  return (
    <div className="bg-white border-b-2 border-zinc-100">
      <div className="max-w-7xl mx-auto px-6 py-6">
        <div className="flex items-center justify-between mb-4">
          <img src="/anmol-logo.jpg" alt="Advanced Anmol Metcomp Pvt Ltd" className="h-12" />
          <button onClick={handleLogout} className="text-sm text-zinc-600 hover:text-zinc-900 font-medium">Logout</button>
        </div>
        <h1 className="font-heading text-3xl font-bold uppercase tracking-tight text-zinc-900">{title}</h1>
        <p className="text-sm text-zinc-500 font-medium mt-1">{user?.name}</p>
        <div className="flex gap-4 mt-6 flex-wrap">
          {NAV.map(([path, label]) => (
            <button
              key={path}
              onClick={() => navigate(path)}
              className={path === active
                ? 'px-4 py-2 bg-zinc-900 text-white text-sm font-bold uppercase tracking-wider rounded-sm'
                : 'px-4 py-2 bg-white border-2 border-zinc-200 text-zinc-900 text-sm font-bold uppercase tracking-wider rounded-sm hover:border-zinc-900'}
              data-testid={`nav-${label.toLowerCase()}`}
            >
              {label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

/** Redirects to HR login unless an HR user is logged in; returns that user */
export function getHRUser() {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    return localStorage.getItem('token') && user?.role === 'hr' ? user : null;
  } catch {
    return null;
  }
}
